import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

import { authChildGuard, authGuard } from './core/routing/guards/auth.guard';
import { noAuthChildGuard, noAuthGuard } from './core/routing/guards/no-auth.guard';

/** Application route map inspired */
export const routes: Routes = [
  // Redirect empty path to dashboard
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },

  // Auth routes for guests
  {
    path: '',
    component: LayoutComponent,
    canActivate: [noAuthGuard],
    canActivateChild: [noAuthChildGuard],
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'confirmation-required',
        loadChildren: () =>
          import('./features/auth/confirmation-required/confirmation-required.routes'),
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./features/auth/forgot-password/forgot-password.routes'),
      },
      {
        path: 'sign-in',
        loadChildren: () => import('./features/auth/sign-in/sign-in.routes'),
      },
      {
        path: 'sign-up',
        loadChildren: () => import('./features/auth/sign-up/sign-up.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('./features/auth/sign-out/sign-out.routes'),
      },
      {
        path: 'unlock-session',
        loadChildren: () => import('./features/auth/unlock-session/unlock-session.routes'),
      },
    ],
  },

  // App pages for authenticated users
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    data: { layout: 'default' },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/pages/dashboard/dashboard.routes'),
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/pages/profile/profile.routes'),
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/pages/settings/settings.routes'),
      },
      {
        path: 'trucks',
        loadChildren: () => import('./features/pages/trucks/trucks.routes'),
      },
      {
        path: 'warehouses',
        loadChildren: () => import('./features/pages/warehouses/warehouses.routes'),
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/pages/orders/orders.routes'),
      },
      {
        path: 'operations/instructions',
        loadChildren: () => import('./features/pages/instructions/instructions.routes'),
      },
      {
        path: 'i18n-showcase',
        loadChildren: () => import('./features/pages/i18n-showcase/i18n-showcase.routes'),
      },
      {
        path: 'help-center',
        loadChildren: () => import('./features/help-center/help-center.routes'),
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./features/pages/maintenance/maintenance.routes'),
      },
      {
        path: 'error',
        loadChildren: () => import('./features/pages/error/error.routes'),
      },
    ],
  },

  // Catch all
  {
    path: '**',
    redirectTo: 'error',
  },
];
